import { useEffect, useState } from 'react'
import { NavLink, Route, Routes } from 'react-router-dom'

import {
  IconeAnalyses,
  IconeAujourdhui,
  IconeJournal,
  IconeRecettes,
  IconeReglages,
} from './composants'
import { appliquerMiseAJour, onMiseAJour } from '../pwa/register'

import { PageAujourdhui } from './pages/Aujourdhui'
import { PageJournal } from './pages/Journal'
import { PageRepas } from './pages/Repas'
import { PageSymptome } from './pages/Symptome'
import { PageSelle } from './pages/Selle'
import { PageJour } from './pages/Jour'
import { PageBibliotheque } from './pages/Bibliotheque'
import { PageRecette } from './pages/Recette'
import { PageIngredient } from './pages/Ingredient'
import { PageAnalyses } from './pages/Analyses'
import { PageStatistiques } from './pages/Statistiques'
import { PageAssociation } from './pages/Association'
import { PageReglages } from './pages/Reglages'
import { PageInstallation } from './pages/Installation'

function BandeauMiseAJour() {
  const [pret, setPret] = useState(false)
  const [enCours, setEnCours] = useState(false)
  useEffect(() => onMiseAJour(setPret), [])
  if (!pret) return null
  return (
    <div className="bandeau-maj" role="status">
      <span className="grandir">Une nouvelle version est prête.</span>
      <button
        type="button"
        className="btn btn--petit"
        disabled={enCours}
        onClick={() => {
          setEnCours(true)
          void appliquerMiseAJour()
        }}
        style={{ background: 'rgba(255,255,255,.18)', borderColor: 'transparent', color: 'inherit' }}
      >
        {enCours ? 'Mise a jour...' : 'Recharger'}
      </button>
    </div>
  )
}

function Onglets() {
  return (
    <nav className="onglets" aria-label="Navigation principale">
      <NavLink to="/" end className="onglet">
        <IconeAujourdhui />
        Aujourd'hui
      </NavLink>
      <NavLink to="/journal" className="onglet">
        <IconeJournal />
        Journal
      </NavLink>
      <NavLink to="/bibliotheque" className="onglet">
        <IconeRecettes />
        Recettes
      </NavLink>
      <NavLink to="/analyses" className="onglet">
        <IconeAnalyses />
        Analyses
      </NavLink>
      <NavLink to="/reglages" className="onglet">
        <IconeReglages />
        Réglages
      </NavLink>
    </nav>
  )
}

export function App() {
  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<PageAujourdhui />} />
        <Route path="/journal" element={<PageJournal />} />

        <Route path="/repas/nouveau" element={<PageRepas />} />
        <Route path="/repas/:id" element={<PageRepas />} />

        <Route path="/symptomes/nouveau" element={<PageSymptome />} />
        <Route path="/symptomes/:id" element={<PageSymptome />} />

        <Route path="/selles/nouvelle" element={<PageSelle />} />
        <Route path="/selles/:id" element={<PageSelle />} />

        <Route path="/jour/:date" element={<PageJour />} />

        <Route path="/bibliotheque" element={<PageBibliotheque />} />
        <Route path="/recettes/nouvelle" element={<PageRecette />} />
        <Route path="/recettes/:id" element={<PageRecette />} />
        <Route path="/ingredients/nouveau" element={<PageIngredient />} />
        <Route path="/ingredients/:id" element={<PageIngredient />} />

        <Route path="/analyses" element={<PageAnalyses />} />
        <Route path="/statistiques" element={<PageStatistiques />} />
        <Route path="/analyses/:cle/:symptome" element={<PageAssociation />} />

        <Route path="/reglages" element={<PageReglages />} />
        <Route path="/installation" element={<PageInstallation />} />

        <Route path="*" element={<PageAujourdhui />} />
      </Routes>
      <BandeauMiseAJour />
      <Onglets />
    </div>
  )
}
